import { Checkbox } from '@mm/components';
import { FilterItem } from '@mm/state/model/AudiencesModel';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { FilterBarItemContentProps } from './FilterBarItem';
import { FilterBarItemEditContainerButtons } from './FilterBarItemEditContainerButtons';

export const PLATFORMS = [
  'facebook',
  'sms',
  'web_chat',
  'instagram',
  'email',
] as const;
export type Platform = typeof PLATFORMS[number];
export const PLATFORM_CAPTIONS: Record<Platform, string> = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  sms: 'SMS',
  web_chat: 'Webchat',
  email: 'Email',
};

export const FilterBarPlatformFilter = ({
  filter,
  onStartEdit,
  onCancelEdit,
  onUpdate,
  styles,
  editing,
  className,
}: FilterBarItemContentProps<FilterItem>) => {
  const selectedPlatformsFromFilter = () =>
    (filter.value as string[]).reduce((acc, platform) => {
      acc[platform] = true;
      return acc;
    }, {});
  const [selectedPlatforms, setSelectedPlatforms] = useState<
    Partial<Record<Platform, boolean>>
  >(selectedPlatformsFromFilter());
  useEffect(() => {
    if (editing) {
      setSelectedPlatforms(selectedPlatformsFromFilter());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editing]);
  const onDone = () => {
    onUpdate({
      ...filter,
      value: Object.entries(selectedPlatforms)
        .filter(([_, val]) => Boolean(val))
        .map(([platform]) => platform),
    });
  };

  return (
    <>
      {editing && (
        <div className={classNames(styles.editContainer, className)}>
          <strong>Filter by platforms:</strong>
          {PLATFORMS.map(platform => (
            <Checkbox
              key={platform}
              isChecked={!!selectedPlatforms[platform]}
              label={PLATFORM_CAPTIONS[platform]}
              onClick={() =>
                setSelectedPlatforms({
                  ...selectedPlatforms,
                  [platform]: !selectedPlatforms[platform],
                })
              }
            />
          ))}
          <FilterBarItemEditContainerButtons
            className={styles.editContainerButtons}
            disableDone={!Object.values(selectedPlatforms).some(Boolean)}
            onDone={onDone}
            onCancelEdit={onCancelEdit}
          />
        </div>
      )}
      <div onClick={onStartEdit} className={styles.content}>
        <strong>Platform{filter.value.length > 1 && 's'}:</strong>&nbsp;
        {!filter.value.length ? (
          <em>Select platform(s)</em>
        ) : (
          (filter.value as string[])
            .map(platform => PLATFORM_CAPTIONS[platform])
            .join(', ')
        )}
      </div>
    </>
  );
};
